module.exports = __webpack_public_path__ + "img/horizontal_7_6_8023.3ea47511.png";